import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { default as Axios, default as axios } from 'axios';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from 'reactstrap';
import { BASE_URL } from 'src/config/api.config';
import Header from '../Header/Header';
import TableInvoice from '../TableInvoice/TableInvoice';
const UserHome = () => {
  const khachHangInfo = JSON.parse(localStorage.getItem('userInfo'));
  const token = localStorage.getItem('token');
  // const navigate = useNavigate();
  const [invoiceList, setInvoiceList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const toggle = () => setModal(!modal);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    searchBySecurityCode();
  }, []);

  const searchBySecurityCode = async () => {
    try {
      let result = await Axios.get(
        `${BASE_URL}/web-api/private/GetInfoInvoiceByKH`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (result.data.error) {
        alert(result.data.error);
      }
      setInvoiceList(result.data.data);
      setIsLoading(false);
    } catch (error) {}
  };

  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');
    toast('Đăng xuất thành công');
    navigate('/');
  };

  const onSubmit = async (data) => {
    //TODO Submit API

    try {
      console.log(`${BASE_URL}/web-api/private/changePassword`);
      const changePass = await axios.post(
        `${BASE_URL}/web-api/private/changePassword`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      //TODO Set token to local
      toast('Đổi mật khẩu thành công');
      reset({ mat_khau: null, xac_nhan_lai_mat_khau: null });
      setModal(false);

      //TODO Chuyển hướng đến trang Home
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <Container>
      <Modal isOpen={modal} toggle={toggle}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader toggle={toggle}>Thay đổi mật khẩu</ModalHeader>
          <ModalBody>
            <Row className="mt-2">
              <Col>
                <input
                  type="password"
                  {...register('mat_khau', { required: true })}
                  placeholder="Nhập mật khẩu mới"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <input
                  type="password"
                  {...register('xac_nhan_lai_mat_khau', { required: true })}
                  placeholder="Nhập lại mật khẩu mới"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Xác nhận
            </Button>
            <Button color="secondary" onClick={toggle}>
              Huỷ
            </Button>
          </ModalFooter>
        </form>
      </Modal>
      <div className="mt-5">
        <Header />
        <hr />
        <div className="mt-5">
          <Row>
            <Col>
              <h3>Xin chào: {khachHangInfo.ten_khach_hang}</h3>
              <h3>Địa chỉ: {khachHangInfo.dia_chi}</h3>
              <h3>Mã Khách Hàng: {khachHangInfo.id_khach_hang}</h3>
            </Col>
            <Col className="mt-3 d-flex" style={{ justifyContent: 'flex-end' }}>
              <Button
                // type="submit"
                onClick={toggle}
                style={{
                  background: '#006926',
                  color: 'white',
                  height: 'fit-content',
                }}>
                <LockOpenIcon />
                Đổi mật khẩu
              </Button>
              <Button
                className="ml-1"
                onClick={handleLogout}
                style={{
                  background: '#006926',
                  color: 'white',
                  height: 'fit-content',
                }}>
                <ExitToAppIcon />
                Đăng Xuất
              </Button>
            </Col>
          </Row>
        </div>
      </div>
      <div className="mt-5">
        {isLoading ? (
          <div className="text-center">
            <Spinner />
          </div>
        ) : (
          <TableInvoice invoiceList={invoiceList} />
        )}
      </div>
    </Container>
  );
};

export default UserHome;
